exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_thumbprint__EjJv1{font-weight:500}", ""]);

// exports
exports.locals = {
	"thumbprint": "style_thumbprint__EjJv1"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/ThumbprintText/style.less
// module id = 1958
// module chunks = 8